<div class="breadcrumb-wrapper">
    <h1>Gerenciamento de Mensagens suspeitas</h1>
  </div>
  <router-outlet></router-outlet>